import React, { useEffect, useMemo } from 'react';
import { TextField, Typography, MenuItem } from '@mui/material';
import _ from 'lodash';
import { useDispatch, useSelector } from 'react-redux';
import { getBaseCodes } from '../../../../modules/auth';
import { getIn } from 'formik';

const BaseCodeSelectbox = ({
  formik,
  name,
  value: propValue, // 1. 외부 주입 value 추가
  label,
  filterObject,
  variant,
  margin,
  size,
  required,
  isLocked,
  isLabelTop,
}) => {
  const dispatch = useDispatch();

  const { baseCodes, loading } = useSelector(({ auth, loading }) => ({
    baseCodes: auth.baseCodes,
    loading: loading['auth/GET_BASECODES'],
  }));

  // 2. 외부 value가 있으면 그것을 쓰고, 없으면 formik 값을 가져옴
  const currentValue = propValue !== undefined ? propValue : (getIn(formik.values, name) ?? '');

  useEffect(() => {
    if (!baseCodes && !loading) {
      dispatch(getBaseCodes());
    }
  }, [dispatch, baseCodes, loading]);

  const options = useMemo(() => {
    if (!baseCodes || baseCodes.length === 0) {
      return currentValue !== '' 
        ? [{ revVal1: currentValue, revVal2: currentValue, isTemp: true }] 
        : [];
    }
    
    const filteredList = _.filter(baseCodes, filterObject).map((item) => ({
      ...item,
      step: item.step !== '' && item.step !== null ? parseInt(item.step) : 0,
    }));
    
    const sortedList = _.orderBy(filteredList, 'step');

    const exists = sortedList.some(opt => opt.revVal2 === currentValue);
    if (currentValue !== '' && !exists) {
      return [{ revVal1: currentValue, revVal2: currentValue, isTemp: true }, ...sortedList];
    }

    return sortedList;
  }, [baseCodes, JSON.stringify(filterObject), currentValue]); 

  return (
    <TextField
      {...formik.getFieldProps(name)}
      value={currentValue} // 3. 가공된 currentValue 적용
      margin={margin || 'none'}
      variant={variant || 'outlined'}
      required={required}
      fullWidth
      select
      size={size}
      label={label}
      error={getIn(formik.touched, name) && Boolean(getIn(formik.errors, name))}
      helperText={getIn(formik.touched, name) && getIn(formik.errors, name)}
      disabled={isLocked}
      SelectProps={{
        readOnly: isLocked,
        displayEmpty: true,
      }}
      InputLabelProps={
        isLabelTop ? { shrink: true, sx: { fontSize: '0.7rem', transform: 'translate(-11px, -9px) scale(1)', color: 'primary.main', backgroundColor: 'white', px: '4px' } } : {}
      }
    >
      <MenuItem value="">
        <Typography variant="body2" color="text.secondary">
          {loading ? '데이터 로딩 중...' : '선택하세요'}
        </Typography>
      </MenuItem>

      {options.map((option) => (
        <MenuItem 
          key={option.isTemp ? `temp-${option.revVal2}` : (option.cd || option.revVal2)} 
          value={option.revVal2 ?? ''}
        >
          {option.revVal1}
        </MenuItem>
      ))}
    </TextField>
  );
};

export default React.memo(BaseCodeSelectbox);
